import { render } from "./MercadoMaestro.vue?vue&type=template&id=2e33e824"
import script from "./MercadoMaestro.vue?vue&type=script&lang=js"
export * from "./MercadoMaestro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__